<template lang="pug">
  v-card.round-lg.pa-4(outlined)
    v-row.mb-5(no-gutters align="center")
      v-col
        .text-xs.neutral500--text.font-semibold Loyalty
      v-spacer
      v-col.text-right(v-if="!loyalty.isFetching && !loyaltySettings.isFetching")
        .d-flex.align-center.justify-end(v-if="loyalty.data")
          v-btn.button-xs.neutral700--text.border-gray.round-2xl.mr-2(outlined :disabled="isDisableRedeemReward" @click="handleRedeemReward") Redeem reward
          v-btn.button-xs.neutral700--text.border-gray.round-2xl(v-if="loyaltySystem === 'stamps'" outlined :disabled="isDisableCollectStamp" @click="handleCollectStamp") Collect stamp
          v-btn.button-xs.neutral700--text.border-gray.round-2xl(v-else outlined @click="handleCollectStamp") Collect point
        template(v-else)
          v-btn.button-xs.neutral700--text.border-gray.round-2xl(outlined @click="handleEnrolToRoyalty") Enrol to loyalty
    div
      template(v-if="allFetching")
        v-skeleton-loader(type="list-item-two-line")
      template(v-else)
        template(v-if="loyalty.data && loyaltySettings.data")
          stamp-collections(v-if="loyaltySystem === 'stamps'" :stamp-collected="loyalty.data.collected" :rewards-position="rewardsPosition")
          point-current-progress(v-if="loyaltySystem === 'points'" :point-collected="loyalty.data.collected" :available-rewards="loyalty.data.available_rewards" point-short-form)
        template(v-else)
          .text-xs.neutral500--text This patient is not enrolled as loyalty member
    .dialogs
      collect-value-dialog(v-if="openCollectValueDialog" :open.sync="openCollectValueDialog" :loyaltySystem="loyaltySystem" :member="loyalty.data" :rewards-position="rewardsPosition" @refetch="fetchLoyalty" @redeem="handleRedeemReward")
      redeem-reward-dialog(v-if="openRedeemRewardDialog" :open.sync="openRedeemRewardDialog" :loyaltySystem="loyaltySystem" :member="loyalty.data" :rewards-position="rewardsPosition" @refetch="fetchLoyalty")
      enrol-new-member-dialog(v-if="openEnrolMemberDialog" :open.sync="openEnrolMemberDialog" @updated="fetchLoyalty" @closed="fetchLoyalty")
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import LoyaltyStampSuccess from "@/components/clinic/checkout/marketing/LoyaltyStampSuccess.vue";
import LoyaltyStampGift from "@/components/clinic/checkout/marketing/LoyaltyStampGift.vue";
import LoyaltyStampNumber from "@/components/clinic/checkout/marketing/LoyaltyStampNumber.vue";
import StampCollections from "@/components/clinic/checkout/marketing/collecting/stamps/StampCollections.vue";
import RedeemRewardDialog from "@/components/clinic/checkout/marketing/redeem/reward/RedeemRewardDialog.vue";
import CollectValueDialog from "@/components/clinic/checkout/marketing/collecting/CollectValueDialog.vue";
import PointCurrentProgress from "@/components/clinic/checkout/marketing/collecting/points/PointCurrentProgress.vue";
import EnrolNewMemberDialog from "@/components/clinic/marketing/dialogs/EnrolNewMemberDialog.vue";

export default {
  components: {
    EnrolNewMemberDialog,
    PointCurrentProgress,
    CollectValueDialog,
    RedeemRewardDialog,
    StampCollections,
    LoyaltyStampNumber,
    LoyaltyStampGift,
    LoyaltyStampSuccess,
  },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      openCollectValueDialog: false,
      openRedeemRewardDialog: false,
      openEnrolMemberDialog: false,
      loyalty: {
        isFetching: true,
        data: null
      },
      loyaltySettings: {
        isFetching: true,
        data: [],
      },
      allFetching: true
    }
  },
  async mounted() {
    try {
      this.allFetching = true
      const allFetching = [this.fetchLoyalty(), this.fetchLoyaltySettings()]
      await Promise.all([...allFetching])
      this.allFetching = false
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    rewardsPosition() {
      return this.loyaltySettings.data?.rewards?.map(reward => reward.tier_value) || []
    },
    isDisableRedeemReward() {
      return !this.loyalty.data || this.loyalty.data.available_rewards.length === 0
    },
    isDisableCollectStamp() {
      return !this.loyalty.data || this.loyalty.data.collected === 10
    },
    loyaltySystem() {
      return this.loyaltySettings.data?.system
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    handleCollectStamp() {
      this.openCollectValueDialog = true
    },
    handleRedeemReward() {
      this.openRedeemRewardDialog = true
    },
    handleEnrolToRoyalty() {
      this.openEnrolMemberDialog = true
    },
    fetchLoyalty() {
      this.loyalty.isFetching = true
      const url = `/loyalty/${this.company.slug}/members`
      const params = {
        customer: this.customer.id,
        dormant: false
      }
      this.$axios.get(url, {params})
          .then(
              ({data}) => {
                if (data.count > 0) {
                  this.loyalty.data = data.results[0]
                }
              }
          )
          .finally(
              () => {
                this.loyalty.isFetching = false
              }
          )
    },
    fetchLoyaltySettings() {
      this.loyaltySettings.isFetching = true
      const url = `/loyalty/${this.company.slug}`
      const params = {
        customer: this.customer.id
      }
      this.$axios.get(url, {params})
          .then(
              ({data}) => {
                this.loyaltySettings.data = data
              }
          )
          .finally(
              () => {
                this.loyaltySettings.isFetching = false
              }
          )
    }
  }
}
</script>

<style scoped>
.border-gray {
  border-color: #c1c1c1;
}
</style>